import React             from 'react';
import { WithStyle }     from 'rewire-ui';
import { Theme }         from '@material-ui/core/styles';
import EntityListView    from '../ui/EntityListView';
import { withStyles }    from '../utility/styles';
import auditLogListModel from './AuditLogListModel';

export const styles = (_theme: Theme) => ({
  contentRoot: {
    marginRight: '0px',
  },
});

export type AuditLogListStyles = ReturnType<typeof styles>;

export interface IAuditLogListProps {
}

export type AuditLogListProps = WithStyle<AuditLogListStyles, IAuditLogListProps>;

class AuditLogListView extends React.PureComponent<AuditLogListProps> {
  constructor(props: AuditLogListProps) {
    super(props);
  }

  render() {
    return (
      <EntityListView model={auditLogListModel} />
    );
  }
}

export default withStyles<IAuditLogListProps>(styles, AuditLogListView);
